import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { TTPAlertsResponse } from './types';

export function useTPAlerts(companyId: number | null) {
  const baseUrl = `tp-alert?companyId=${companyId}`;

  const {
    data,
    error,
    mutate,
  }: {
    data?: TTPAlertsResponse;
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    companyId ? baseUrl : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
    isLoading: !data && !error,
  };
}
